import type { IFinanceSocketSectionId, ISubcontractGridRow } from '@app/types';

export function getProjectGridSubcontractTotal(
  sectionId: IFinanceSocketSectionId,
  subcontractGridRows: ISubcontractGridRow[],
  isEstimate = false
) {
  const limitTotal = subcontractGridRows.reduce((acc, { limitValues }) => {
    return acc + limitValues.reduce((acc2, { value }) => acc2 + value, 0);
  }, 0);

  const billTotal = subcontractGridRows.reduce((acc, { billValues }) => {
    return acc + billValues.reduce((acc2, { value }) => acc2 + value, 0);
  }, 0);

  const authorizedTotal = subcontractGridRows.reduce((acc, cur) => acc + cur.authorizedManualValue, 0);
  const remainingTotal = isEstimate ? authorizedTotal - billTotal : limitTotal - billTotal;
  const forecastTotal = subcontractGridRows.reduce((acc, cur) => acc + cur.forecastValue, 0);

  switch (sectionId) {
    case 'budget':
      return isEstimate ? authorizedTotal : limitTotal;
    case 'actual':
      return billTotal;
    case 'remaining':
      return remainingTotal;
    case 'forecast':
      return forecastTotal;
  }
}
